// Module-level cache to persist data across component mounts/unmounts
const tabCache = {
  // Product Categories cache
  productCategories: {
    data: null,
    firstLoad: true,
  },

  // Vendor Requests cache
  vendorRequests: {
    data: null,
    firstLoad: true,
  },

  // Vendor Change Requests cache
  vendorChangeRequests: {
    data: null,
    firstLoad: true,
  },

  // Vendor Products - Categories cache
  vendorProductsCategories: {
    data: null,
    firstLoad: true,
  },

  // Vendor Products - Products cache
  vendorProductsProducts: {
    data: null,
    firstLoad: true,
  },

  // Users (Marketplace) cache
  users: {
    data: null,
    firstLoad: true,
  },

  // Contacts cache
  contacts: {
    data: null,
    firstLoad: true,
  },

  // Organization Events cache
  organizationEvents: {
    data: null,
    firstLoad: true,
  },

  // Reports cache
  reports: {
    data: null,
    firstLoad: true,
  },

  // Boost Pricing cache
  boostPricing: {
    data: null,
    firstLoad: true,
  },

  // Vendor Boost Pricing cache
  vendorBoostPricing: {
    data: null,
    firstLoad: true,
  },
  ticketCommission: {
    data: null,
    firstLoad: true,
  },


  // Explore - Events cache
  exploreEvents: {
    data: null,
    firstLoad: true,
  },

  // Explore - Posts cache
  explorePosts: {
    data: null,
    firstLoad: true,
  },

  // Explore - Garages cache
  exploreGarages: {
    data: null,
    firstLoad: true,
  },

  // Event & Car Types cache
  eventCarTypes: {
    data: null,
    firstLoad: true,
  },

  // Event & Car Types - Event Types cache
  eventTypes: {
    data: null,
    firstLoad: true,
  },

  // Event & Car Types - Car Types cache
  carTypes: {
    data: null,
    firstLoad: true,
  },

  // Dashboard cache
  dashboard: {
    data: null,
    commissionData: null,
    firstLoad: true,
  },

  // Ticket Revenue cache
  ticketRevenue: {
    data: null,
    firstLoad: true,
  },

  // Notification Users cache
  notificationUsers: {
    data: null,
    firstLoad: true,
  },

  // Gamification - Badges cache
  gamificationBadges: {
    data: null,
    firstLoad: true,
  },

  // Gamification - Achievement Badges cache
  gamificationAchievementBadges: {
    data: null,
    firstLoad: true,
  },

  // Gamification - Feature Unlocks cache
  gamificationFeatureUnlocks: {
    data: null,
    firstLoad: true,
  },

  // Gamification - Daily Tasks cache
  gamificationDailyTasks: {
    data: null,
    firstLoad: true,
  },
};

export default tabCache;

